let orderInfoApi = {
  name: "订单详情",
  updateTime: "2020-05-30 10:00:00",
  methods: 'post',
  url: 'ygw.api.order.detail',
  request: [{
    params: 'orderNo',
    type: "String",
    required: true,
    length: 32,
    description: {
      text: '订单号',
      value: []
    },
    example: 'YG19093324559008210'
  }],
  reseponse: [{
    params: '+baseInfo',
    type: "Object",
    required: true,
    length: '',
    description: {
      text: '基础信息',
      value: []
    },
    example: ' '
  }, {
    params: '└goodsCount',
    type: "Number",
    required: true,
    length: '',
    description: {
      text: '购买商品行数',
      value: []
    },
    example: '2'
  }, {
    params: '└orderCreateTime',
    type: "String",
    required: true,
    length: '',
    description: {
      text: '订单创建时间',
      value: []
    },
    example: ' 2019-09-12 20:24:55'
  }, {
    params: '└appId',
    type: "String",
    required: true,
    length: '32',
    description: {
      text: '应用 appId',
      value: []
    },
    example: '908302134392578486'
  }, {
    params: '└orderRemark',
    type: "String",
    required: false,
    length: '',
    description: {
      text: '订单备注信息',
      value: []
    },
    example: '请开 13 点增值税。'
  }, {
    params: 'orderNo',
    type: "String",
    required: true,
    length: '32',
    description: {
      text: '订单号',
      value: []
    },
    example: 'YG1909122024559008210'
  }, {
    params: 'orderState',
    type: "Number",
    required: true,
    length: '4',
    description: {
      text: '订单状态',
      value: ['101：待支付', '102：待审核', '199：待发货', '449：待收货', '501：已完成', '601：已关闭']
    },
    example: '601'
  }, {
    params: '+receiptInfo',
    type: "Object",
    required: true,
    length: '',
    description: {
      text: '收货详情',
      value: []
    },
    example: ''
  }, {
    params: '└receiver',
    type: "String",
    required: false,
    length: '20',
    description: {
      text: '收件人',
      value: []
    },
    example: '张三'
  }, {
    params: '└receiverPhone',
    type: "String",
    required: false,
    length: '11',
    description: {
      text: '收件人电话',
      value: []
    },
    example: '18888888888'
  }, {
    params: '└detailAddress',
    type: "String",
    required: false,
    length: '200',
    description: {
      text: '收件人地址',
      value: []
    },
    example: '广东省深圳市 XXXXXX'
  }, {
    params: '└linkmanName',
    type: "String",
    required: true,
    length: '20',
    description: {
      text: '下单联系人名称',
      value: []
    },
    example: '张三'
  }, {
    params: '└linkmanPhone',
    type: "String",
    required: true,
    length: '11',
    description: {
      text: '下单联系人电话',
      value: []
    },
    example: '18888888888'
  }, {
    params: '+goodsList',
    type: "Object",
    required: true,
    length: '20',
    description: {
      text: '商品列表',
      value: []
    },
    example: ''
  }, {
    params: '└unitPrice',
    type: "Number",
    required: true,
    length: '',
    description: {
      text: '商品单价（单位元）',
      value: []
    },
    example: '0.002700'
  }, {
    params: '└specs',
    type: "String",
    required: true,
    length: '',
    description: {
      text: '商品封装规格',
      value: []
    },
    example: '0603(1608)'
  }, {
    params: '└brandName',
    type: "String",
    required: true,
    length: '50',
    description: {
      text: '商品品牌名称',
      value: []
    },
    example: '美隆'
  }, {
    params: '└goodsAmount',
    type: "Number",
    required: true,
    length: '',
    description: {
      text: '商品价格（单位元）',
      value: []
    },
    example: '13.50'
  }, {
    params: '└goodsQuantity',
    type: "Number",
    required: true,
    length: '10',
    description: {
      text: '商品数量（单位 psc）',
      value: []
    },
    example: '5000'
  }, {
    params: '└goodsCode',
    type: "String",
    required: true,
    length: '',
    description: {
      text: '油柑编码',
      value: []
    },
    example: '06SUP005296'
  }, {
    params: '+distributionInfo',
    type: "Object",
    required: true,
    length: '',
    description: {
      text: '配送信息',
      value: []
    },
    example: ''
  }, {
    params: '└expressName',
    type: "String",
    required: true,
    length: '30',
    description: {
      text: '快递公司名称',
      value: []
    },
    example: '顺丰快递（标快）'
  }, {
    params: '└expressNo',
    type: "String",
    required: true,
    length: '50',
    description: {
      text: '快递单号',
      value: []
    },
    example: '444020290492'
  }, {
    params: '└distributionType',
    type: "Number",
    required: true,
    length: '2',
    description: {
      text: '配送方式',
      value: ['0:邮寄', '1:到店自提', '2:送货上门']
    },
    example: '0'
  }, {
    params: '└storeTime',
    type: "String",
    required: false,
    length: '50',
    description: {
      text: '到店时间（配送方式为到店自提）',
      value: []
    },
    example: '2019-09-13 10:40:00'
  }, {
    params: '+payInfo',
    type: "Object",
    required: true,
    length: '',
    description: {
      text: '支付信息',
      value: []
    },
    example: ''
  }, {
    params: '└paySerialNo',
    type: "String",
    required: false,
    length: '100',
    description: {
      text: '支付序列编号',
      value: []
    },
    example: '2019091222001455411052074465'
  }, {
    params: '└payType',
    type: "Number",
    required: false,
    length: '2',
    description: {
      text: '支付类型',
      value: ['0:微信', '1:支付宝']
    },
    example: '1'
  }, {
    params: '└payAmount',
    type: "Number",
    required: true,
    length: '',
    description: {
      text: ' 支付金额',
      value: []
    },
    example: '13.50'
  }, {
    params: '└expressAmount',
    type: "Number",
    required: true,
    length: '',
    description: {
      text: '快递金额',
      value: []
    },
    example: '12.00'
  }, {
    params: '└payTime',
    type: "String",
    required: false,
    length: '',
    description: {
      text: ' 支付时间',
      value: []
    },
    example: '2019-09-12 20:25:15'
  }, {
    params: '└goodsAmount',
    type: "Number",
    required: true,
    length: '',
    description: {
      text: ' 商品金额',
      value: []
    },
    example: '13.50'
  }, {
    params: '└payState',
    type: "Number",
    required: false,
    length: '20',
    description: {
      text: '支付状态',
      value: ['0:待支付', '1:已支付', '-1:支付失败']
    },
    example: '1'
  }],
  code: {
    sign: "94c0d23036d9ef73c551c8c49497d802",
    appId: "9527",
    method: "ygw.api.order.detail",
    params: JSON.stringify({
      orderNo: 'YG1909122024559008210'
    })
  }
}

export default orderInfoApi;